/* CITYCAR Studio. Commerce responses and prices come from Shopify only. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const root = window.CITYCAR?.root || '/';
  const endpoint = path => `${root.replace(/\/$/, '')}/${path}`;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const announce = text => { const el = $('#CCStatus'); if (el) el.textContent = text; };
  const showError = (scope, text) => { const el = $('[data-form-error]', scope); if (el) el.textContent = text; announce(text); };
  let lastFocus;
  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    lastFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('dialog-open');
  }
  function closeDialog(dialog) { dialog?.close(); }
  $$('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('dialog-open');
      if (lastFocus?.isConnected) lastFocus.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
  });
  let zoomPhotos = [], zoomIndex = 0, zoomRequest = 0;
  function paintZoom() {
    const photo = zoomPhotos[zoomIndex], dialog = $('#CCZoom');
    if (!photo || !dialog) return;
    const image = $('.zoom-image img', dialog);
    const request=++zoomRequest;
    image.src = photo.preview || photo.src; image.alt = photo.alt;
    if(photo.src && photo.src!==image.src){const high=new Image();high.src=photo.src;high.decode().then(()=>{if(request===zoomRequest&&dialog.open)image.src=high.src;}).catch(()=>{});}
    dialog.classList.remove('is-enlarged');
    $('[data-zoom-toggle]', dialog).setAttribute('aria-label','Збільшити');
  }
  async function focusMedia(gallery, id) {
    const item = $$('.gallery-item', gallery).find(el => el.dataset.mediaId === String(id));
    const stage = $('[data-gallery-stage]', gallery);
    if (!item || !stage) return;
    const token=String(id);gallery.dataset.loadingMedia=token;const img=$('img',item);if(img){img.loading='eager';try{await img.decode();}catch{}}if(gallery.dataset.loadingMedia!==token)return;
    stage.scrollTo({left: item.offsetLeft, top: 0, behavior: reduced ? 'auto' : 'smooth'});
    $$('[data-gallery-target]', gallery).forEach(button => button.setAttribute('aria-current', String(button.dataset.galleryTarget === String(id))));
  }
  const bundleMoney = n => new Intl.NumberFormat(document.documentElement.lang || 'uk', {style:'currency',currency:window.CITYCAR?.currency || 'UAH',minimumFractionDigits:n % 100 === 0 ? 0 : 2,maximumFractionDigits:2}).format(n / 100);
  function updateBundle(section) {
    if (!section) return;
    const info=$('[data-product-info]',section),form=$('.product-form',section);
    if (!info || !form) return;
    const quantity=$('[name=quantity]',form),count=Number(quantity?.value || 0),unit=Number(info.dataset.unitPrice);
    let valid=Number.isInteger(count)&&count>0&&(!quantity||quantity.checkValidity())&&Number.isFinite(unit),addons=0,addonCount=0;
    for (const card of $$('[data-addon-selected="true"]',section)) {
      const field=$('[name=id]',card),option=field?.selectedOptions?.[0]||field,q=$('[name=quantity]',card),amount=Number(q?.value||0),price=Number(option?.dataset.price);
      if (!field?.value || !Number.isInteger(amount) || amount<1 || !q?.checkValidity() || !Number.isFinite(price)) {valid=false;continue;}
      addons+=price*amount;addonCount+=amount;
    }
    const put=(sel,text)=>$$(sel,section).forEach(n=>n.textContent=text);
    put('[data-bundle-main-label]','Основний товар × '+(count>0?count:'—'));
    put('[data-bundle-main]',valid?bundleMoney(unit*count):'—');
    put('[data-bundle-addons-label]','Доповнення × '+addonCount);put('[data-bundle-addons]',bundleMoney(addons));
    $$('[data-bundle-addons-row]',section).forEach(n=>n.hidden=addonCount===0);
    put('[data-bundle-total]',valid?bundleMoney(unit*count+addons):'—');
    put('[data-bundle-caption]',valid?(addonCount?'Разом · з доповненнями':'Разом · без доповнень'):'Перевірте кількість');
    const summary=$('[data-bundle-summary]',section);if(summary){summary.dataset.total=valid?String(unit*count+addons):'';summary.dataset.addonCount=String(addonCount);}
  }
  const updateBundles=()=>$$('[data-product-section]').forEach(updateBundle);
  document.addEventListener('citycar:content-updated',updateBundles);
  document.addEventListener('citycar:bundle-changed',updateBundles);
  const variantRequests = new WeakMap();
  const addonSelections = new WeakMap();
  function rememberAddons(section){
    const saved=addonSelections.get(section)?.items||new Map();
    for(const card of $$('[data-addon-product]',section)){
      const form=$('form[data-product-form]',card);if(!form)continue;
      const data=new FormData(form);
      saved.set(card.dataset.addonProduct,{selected:card.dataset.addonSelected==='true',id:String(data.get('id')||''),quantity:String(data.get('quantity')||1)});
    }
    addonSelections.set(section,{source:$('[data-product-info]',section),items:saved});
  }
  function restoreAddons(){
    for(const section of $$('[data-product-section]')){
      const snapshot=addonSelections.get(section);if(!snapshot||snapshot.source===$('[data-product-info]',section))continue;const saved=snapshot.items;
      for(const card of $$('[data-addon-product]',section)){
        const item=saved.get(card.dataset.addonProduct),form=$('form[data-product-form]',card);if(!item||!form)continue;
        const id=$('[name=id]',form),quantity=$('[name=quantity]',form);
        if(id?.tagName==='SELECT'&&[...id.options].some(o=>o.value===item.id&&!o.disabled)){id.value=item.id;id.dispatchEvent(new Event('change',{bubbles:true}));}
        const available=id?.value===item.id;
        if(quantity&&available)quantity.value=item.quantity;
        card.dataset.addonSelected=String(item.selected&&available);
        const button=$('button[name=add]',form);if(button){button.setAttribute('aria-pressed',card.dataset.addonSelected);button.textContent=item.selected&&available?'✓ Обрано':'+ До комплекту';}
        saved.delete(card.dataset.addonProduct);
      }
    }
  }
  document.addEventListener('citycar:addons-ready',()=>{restoreAddons();updateBundles();});
  async function changeVariant(input) {
    const section = input.closest('[data-product-section]');
    if (!section) return;
    if (input.dataset.productUrl && input.dataset.productUrl !== section.dataset.productUrl) {
      location.href = input.dataset.productUrl; return;
    }
    variantRequests.get(section)?.abort();
    const controller = new AbortController(); variantRequests.set(section, controller);
    rememberAddons(section);
    const values = $$('[data-option-value]:checked,select[data-option-value]', section).map(el => el.value);
    const url = new URL(section.dataset.productUrl, location.origin);
    if(input.matches('[data-variant-select]'))url.searchParams.set('variant',input.value);else if(input.dataset.variantId)url.searchParams.set('variant',input.dataset.variantId);else url.searchParams.set('option_values', values.join(','));
    url.searchParams.set('section_id', section.dataset.productSection);
    // Preserve only the main purchase form. Add-on parent variant IDs must come from the new Shopify response.
    const purchaseForm = $('.product-form', section);
    const saved = purchaseForm ? $$('input[name="quantity"],input[name^="properties["]', purchaseForm).map(el => [el.name, el.value]) : [];
    const vehicleOpen = !!$('.vehicle[open]', section);
    const committedVariant = $('[data-product-info]', section)?.dataset.variantId;
    const focusName = input.name, focusValue = input.value;
    $$('button[name="add"],[data-mobile-add]', section).forEach(button => button.disabled = true);
    section.setAttribute('aria-busy', 'true');
    delete section.dataset.variantError;
    showError(section, '');
    try {
      const response = await fetch(url, {signal: controller.signal});
      if (!response.ok) throw new Error('variant');
      const responseHTML = await response.text();
      if (controller.signal.aborted || variantRequests.get(section) !== controller) return;
      const html = parse(responseHTML), next = $('[data-product-info]', html);
      if (!next) throw new Error('variant');
      $('[data-product-info]', section).replaceWith(next);
      for (const [name, value] of saved) {
        const nextPurchaseForm = $('.product-form', next);
        const field = nextPurchaseForm && $$('input', nextPurchaseForm).find(el => el.name === name);
        if (!field) continue;
        if (name === 'quantity') {
          const min = Number(field.min) || 1, step = Number(field.step) || 1;
          field.value = Math.min(field.max ? Number(field.max) : Infinity, Math.max(min, min + Math.round((Number(value) - min) / step) * step));
        } else field.value = value;
      }
      if (vehicleOpen && $('.vehicle', next)) $('.vehicle', next).open = true;
      const mobile = $('.mobile-purchase', section), nextMobile = $('.mobile-purchase', html);
      if (mobile && nextMobile) mobile.replaceWith(nextMobile);
      const variant = next.dataset.variantId;
      if (variant) {
        const current = new URL(location.href);
        current.searchParams.set('variant', variant); current.searchParams.delete('option_values');
        history.replaceState({}, '', current);
      }
      // Organizer size changes update the actual gallery image, thumbnail and zoom source.
      const gallery = $('[data-gallery]', section);
      const returnedCover = $('[data-media-id="cover"]', html);
      const updatedImage = returnedCover && $('[data-organizer-image],[data-generated-product-image]', returnedCover);
      if (updatedImage && gallery) {
        const currentCover = $('[data-media-id="cover"]', gallery);
        const currentThumb = $('[data-gallery-target="cover"]', gallery);
        const returnedThumb = $('[data-gallery-target="cover"]', html);
        if (currentCover) currentCover.replaceWith(returnedCover);
        if (currentThumb && returnedThumb) currentThumb.replaceWith(returnedThumb);
        focusMedia(gallery, 'cover');
      } else if (next.dataset.featuredMedia) focusMedia(gallery, next.dataset.featuredMedia);
      const focusTarget=input.matches('[data-variant-select]')?$('[data-variant-trigger]',next):$$('[data-option-value]',next).find(el=>el.name===focusName&&el.value===focusValue);focusTarget?.focus({preventScroll:true});
      announce($('.price-row', next)?.textContent.trim() || 'Варіант оновлено');
      document.dispatchEvent(new CustomEvent('citycar:content-updated'));
    } catch (error) {
      if (error.name === 'AbortError' || controller.signal.aborted || variantRequests.get(section) !== controller) return;
      // Fail closed: the previous variant must not be added under a newly selected label.
      section.dataset.variantError = 'true';
      const selector = $('[data-variant-select]', section);
      if (selector && committedVariant) selector.value = committedVariant;
      showError(section, 'Не вдалося завантажити варіант. Оберіть його ще раз або оновіть сторінку.');
    } finally {
      if (variantRequests.get(section) === controller) section.removeAttribute('aria-busy');
    }
  }
  const sectionIds = () => [...new Set($$('[data-cart-section]').map(el => el.dataset.cartSection))].slice(0, 5);
  let cartRefreshRevision = 0;
  function formatCartMoney(){
    const currency=$('[data-cart-meta]')?.dataset.currency||window.CITYCAR?.currency;
    if(currency)window.CITYCAR.currency=currency;
    if(!currency)return;
    $$('[data-cart-money]').forEach(el=>{const amount=Number(el.dataset.cartMoney);if(Number.isFinite(amount))el.textContent=new Intl.NumberFormat(document.documentElement.lang||'uk',{style:'currency',currency,minimumFractionDigits:amount%100?2:0,maximumFractionDigits:2}).format(amount/100);});
  }
  document.addEventListener('DOMContentLoaded',formatCartMoney);
  formatCartMoney();
  async function refreshCart(sections) {
    const revision = ++cartRefreshRevision;
    const ids = sectionIds();
    if (!sections || ids.some(id => !sections[id])) {
      const url = new URL(window.CITYCAR?.cart || endpoint('cart'), location.origin);
      url.searchParams.set('sections', ids.join(','));
      const response = await fetch(url);
      if (!response.ok) throw new Error('cart-refresh');
      sections = await response.json();
    }
    if (revision !== cartRefreshRevision) return;
    for (const id of ids) {
      if (!sections[id]) throw new Error('cart-refresh');
      const html = parse(sections[id]), next = $('[data-cart-surface]', html);
      const current = $$('[data-cart-surface]').find(el => el.dataset.cartSection === id);
      if (!current || !next) throw new Error('cart-refresh');
      current.replaceWith(next);
    }
    formatCartMoney();
    const count = $('[data-cart-meta]')?.dataset.count || '0';
    $$('[data-cart-count]').forEach(el => el.textContent = count);
    loadRecommendations();
    document.dispatchEvent(new CustomEvent('citycar:cart-updated', {detail:{count:Number(count)}}));
  }
  let cartBusy = false;
  const cartDisabled = new Map();
  function cartLock(value) {
    cartBusy = value;
    $$('[data-cart-surface]').forEach(el => el.setAttribute('aria-busy', String(value)));
    if (value) $$('[data-cart-quantity],[data-cart-step],[data-cart-surface] button[name=add],[data-cart-discount] button,[data-cart-form] button').forEach(el => {
      if (!cartDisabled.has(el)) cartDisabled.set(el, el.disabled);
      el.disabled = true;
    });
    else { for (const [el, disabled] of cartDisabled) if (el.isConnected) el.disabled = disabled; cartDisabled.clear(); }
  }
  async function addProduct(form) {
    if (cartBusy || form.dataset.busy || !form.reportValidity()) return;
    const section = form.closest('[data-product-section]');
    if (section?.hasAttribute('aria-busy') || section?.dataset.variantError) return;
    const forms = [form];
    if (form.matches('.product-form') && section) {
      for (const card of $$('[data-addon-selected="true"]', section)) {
        const addon = $('form[data-product-form]', card);
        if (addon) forms.push(addon);
      }
    }
    if (forms.some(f => !f.reportValidity())) return;
    const items = forms.map(f => {
      const data = new FormData(f), properties = {};
      for (const [name,value] of data) {const match = name.match(/^properties\[(.+)\]$/);if(match && value) properties[match[1]]=String(value);}
      return {id:String(data.get('id')||''),quantity:Number(data.get('quantity')||1),...(Object.keys(properties).length?{properties}:{})};
    });
    if(items.some(item=>!/^\d+$/.test(item.id)||!Number.isInteger(item.quantity)||item.quantity<1)){showError(form,'Оберіть доступний варіант і кількість.');return;}
    const payload={items,sections:sectionIds(),sections_url:location.pathname};
    const buttons = $$('button[name="add"],[data-mobile-add]', section || form);
    const disabledBefore=buttons.map(el=>el.disabled);
    form.dataset.busy = 'true'; cartLock(true); showError(form, '');
    buttons.forEach(el => el.disabled = true);
    let added = false;
    try {
      const response = await fetch(endpoint('cart/add.js'), {method:'POST',body:JSON.stringify(payload),headers:{'Content-Type':'application/json',Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) { showError(form, typeof result.description === 'string' ? result.description : 'Товар не вдалося додати. Перевірте доступну кількість.'); return; }
      added = true;
      for(const addedItem of result.items||[result]) document.dispatchEvent(new CustomEvent('citycar:product-added',{detail:{product_id:addedItem.product_id,variant_id:addedItem.variant_id||addedItem.id,quantity:items.find(i=>i.id===String(addedItem.variant_id||addedItem.id))?.quantity||1,unit_price:Number(addedItem.final_price??addedItem.price??0)/100,placement:section?'product_page':'recommendation'}}));
      if(form.matches('.product-form'))$$('[data-addon-selected="true"]',section).forEach(card=>{card.dataset.addonSelected='false';const b=$('button[name="add"]',card);if(b){b.setAttribute('aria-pressed','false');b.textContent='+ До комплекту';}});
      updateBundle(section);
      await refreshCart(result.sections);
      announce('Товар додано до кошика'); openDialog($('#CCCart'));
    } catch (_) {
      showError(form, added ? 'Товар додано. Не вдалося оновити вікно кошика — відкрийте кошик через меню.' : 'Не вдалося підтвердити додавання. Перевірте кошик перед повторною спробою.');
    } finally { delete form.dataset.busy; cartLock(false); buttons.forEach((el,i) => el.disabled = disabledBefore[i]); }
  }
  async function changeCart(element, quantity) {
    if (cartBusy) return;
    const surface = element.closest('[data-cart-surface]'), key = element.closest('[data-line-key]')?.dataset.lineKey;
    if (!key || !Number.isInteger(quantity) || quantity < 0) return;
    cartLock(true); showError(surface, '');
    const focusedKey = key, removing = quantity === 0;
    try {
      const response = await fetch(endpoint('cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key, quantity, sections:sectionIds(), sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Не вдалося змінити кількість.');
      await refreshCart(result.sections);
      announce(removing ? 'Товар видалено з кошика' : 'Кошик оновлено');
      const currentSurface = $$('[data-cart-surface]').find(el => el.dataset.cartSection === surface.dataset.cartSection);
      const currentLine = $$('[data-line-key]', currentSurface || document).find(el => el.dataset.lineKey === focusedKey);
      if (!removing) $('[data-cart-quantity]', currentLine || currentSurface || document)?.focus({preventScroll:true});
    } catch (error) {
      // Fetch the authoritative cart after a failure; never synthesize a successful change.
      try { await refreshCart(); } catch (_) { /* The full cart link remains available. */ }
      showError($$('[data-cart-surface]').find(el => el.dataset.cartSection === surface.dataset.cartSection) || surface,
        error.message !== 'Failed to fetch' && error.message !== 'cart-refresh' ? error.message : 'Не вдалося підтвердити зміни. Оновіть сторінку кошика.');
    } finally { cartLock(false); }
  }
  async function applyDiscount(form){
    if(cartBusy||!form.reportValidity())return;
    const surface=form.closest('[data-cart-surface]'),surfaceId=surface.dataset.cartSection,code=new FormData(form).get('discount').trim();if(!code)return;
    cartLock(true);form.querySelector('button').disabled=true;
    const status=(message)=>{const target=$$('[data-cart-surface]').find(x=>x.dataset.cartSection===surfaceId);const node=target?.querySelector('[data-discount-status]');if(node)node.textContent=message;};
    try{
      const response=await fetch(endpoint('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code,sections:sectionIds(),sections_url:location.pathname})});
      const result=await response.json();if(!response.ok)throw Error('discount');await refreshCart(result.sections);
      const codes=result.discount_codes||[],known=codes.find(x=>String(x.code).toLowerCase()===code.toLowerCase());
      if(known?.applicable===false)status('Цей промокод не підходить до товарів у кошику.');
      else if(known?.applicable===true)status('Промокод застосовано. Суму оновлено Shopify.');
      else status('Код перевірено Shopify. Застосовані знижки відображаються у підсумку кошика.');
    }catch{status('Не вдалося перевірити промокод. Спробуйте ще раз.');}
    finally{cartLock(false);if(form.isConnected)form.querySelector('button').disabled=false;}
  }

  async function loadRecommendations() {
    await Promise.allSettled($$('[data-recommendations]:not([data-loaded])').map(async el => {
      el.dataset.loaded = 'true';
      try {
        const url = new URL(el.dataset.recommendations, location.origin);
        if (url.origin !== location.origin) return;
        const response = await fetch(url); if (!response.ok) return;
        const next = $('[data-recommendation-results]', parse(await response.text())); if (!next) return;
        const excluded = (el.dataset.exclude || '').split(',');
        if (el.closest('.cart-related')) $('.row-heading', next)?.remove();
        $$('[data-product-id]', next).forEach(card => {if (excluded.includes(card.dataset.productId)) card.remove();});
        if ($('.product-card', next)) {el.replaceChildren(...next.childNodes);document.dispatchEvent(new CustomEvent('citycar:content-updated'));}
      } catch (_) { /* Recommendations are optional; the cart remains functional. */ }
    }));
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a'); if (!target) return;
    if (target.matches('[data-close-dialog]')) closeDialog(target.closest('dialog'));
    if (target.matches('[data-open-cart]')) { event.preventDefault(); openDialog($('#CCCart')); refreshCart().catch(() => {location.href = window.CITYCAR?.cart || endpoint('cart');}); }
    if (target.matches('[data-gallery-target]')) focusMedia(target.closest('[data-gallery]'), target.dataset.galleryTarget);
    if (target.matches('[data-zoom]')) {
      const gallery = target.closest('[data-gallery]');
      const buttons = $$('[data-zoom]', gallery);
      zoomPhotos = buttons.map(button => ({src:button.dataset.full || $('img',button)?.dataset.full || $('img',button)?.currentSrc || $('img',button)?.src,preview:$('img',button)?.currentSrc||$('img',button)?.src,alt:$('img',button)?.alt || ''}));
      zoomIndex = buttons.indexOf(target); paintZoom(); openDialog($('#CCZoom'));
    }
    if (target.matches('[data-zoom-prev],[data-zoom-next]')) { zoomIndex = (zoomIndex + (target.matches('[data-zoom-next]') ? 1 : -1) + zoomPhotos.length) % zoomPhotos.length; paintZoom(); }
    if (target.matches('[data-zoom-toggle]')) { const active = $('#CCZoom').classList.toggle('is-enlarged'); target.setAttribute('aria-label',active?'Зменшити':'Збільшити'); }
    if (target.matches('[data-rail-prev],[data-rail-next]')) {
      const rail = $('[data-rail]', target.closest('section'));
      rail?.scrollBy({left:rail.clientWidth * .8 * (target.matches('[data-rail-next]') ? 1 : -1),behavior:reduced ? 'auto' : 'smooth'});
    }
    if (target.matches('[data-play-video]')) {
      const wrap = target.closest('[data-video-id]'), id = wrap.dataset.videoId;
      if (!/^[\w-]+$/.test(id)) return;
      const iframe = document.createElement('iframe');
      iframe.src = wrap.dataset.videoType === 'youtube' ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1` : `https://player.vimeo.com/video/${id}?autoplay=1`;
      iframe.title = target.getAttribute('aria-label'); iframe.allow = 'autoplay; fullscreen; picture-in-picture'; iframe.allowFullscreen = true;
      wrap.replaceChildren(iframe);
    }
    if (target.matches('[data-cart-step]')) { const field=$('[data-cart-quantity]',target.closest('[data-line-key]'));if(field)changeCart(target,Math.max(0,Number(field.value)+Number(target.dataset.cartStep))); }
    if (target.matches('[data-cart-remove]')) { event.preventDefault(); changeCart(target, 0); }
  });
  document.addEventListener('keydown', event => {
    if ($('#CCZoom')?.open && ['ArrowLeft','ArrowRight'].includes(event.key)) {
      event.preventDefault(); zoomIndex = (zoomIndex + (event.key === 'ArrowRight' ? 1 : -1) + zoomPhotos.length) % zoomPhotos.length; paintZoom();
    }
  });
  let cartQuantityTimer;
  document.addEventListener('change', event => {
    if (event.target.matches('[data-option-value],[data-variant-select]')) changeVariant(event.target);
    if (event.target.matches('[data-cart-quantity]')) {clearTimeout(cartQuantityTimer); changeCart(event.target, Number(event.target.value));}
    if(event.target.matches('[name=id],[name=quantity]'))updateBundle(event.target.closest('[data-product-section]'));
  });
  document.addEventListener('input', event => {
    if(event.target.matches('[name=quantity]'))updateBundle(event.target.closest('[data-product-section]'));
    if (event.target.matches('[data-cart-quantity]')) {
      const field=event.target; clearTimeout(cartQuantityTimer);
      cartQuantityTimer=setTimeout(() => {if(field.isConnected && field.value !== '' && field.checkValidity()) changeCart(field, Number(field.value));},450);
    }
    if (event.target.matches('[data-comparison] input')) event.target.closest('[data-comparison]').style.setProperty('--split', `${event.target.value}%`);});
  document.addEventListener('submit', event => {if(event.target.matches('[data-cart-discount]')){event.preventDefault();applyDiscount(event.target);return;}if (event.target.matches('[data-product-form]')) {event.preventDefault();const card=event.target.closest('.pdp-addon');if(card&&card.closest('[data-product-section]')){const selected=card.dataset.addonSelected==='true';if(!selected&&!event.target.reportValidity())return;card.dataset.addonSelected=String(!selected);const button=event.target.querySelector('button[name=add]');if(button){button.textContent=selected?'+ До комплекту':'✓ Обрано';button.setAttribute('aria-pressed',String(!selected));}updateBundle(card.closest('[data-product-section]'));announce(selected?'Доповнення прибрано з комплекту':'Доповнення обрано. Додайте комплект основною кнопкою.');return;}addProduct(event.target);}});
  document.addEventListener('shopify:section:load', loadRecommendations);
  loadRecommendations();
  updateBundles();
})();
